<template>
  <section v-if="show" class="video-bar d-flex bg-black justify-content-center" id="qna-video">
      <div class="content__column">
        <div class="iframe__wrapper">
          <iframe v-if="videoId" class="iframe border border-grey-900" :src="`https://www.youtube.com/embed/${videoId}?autoplay=1`"></iframe>
        </div>
      </div>
  </section>
</template>

<script>
    export default {
        name: "NccQuestionVideoBar",
        computed: {
            videoId() {
                const selectedQuestion = this.$store.getters['selectedQuestion']

                if(!selectedQuestion) {
                    return null
                }

                return selectedQuestion.videoId
            },
          show() {
                return this.$store.getters['showVideoBar'];
            }
        }
    }
</script>

<style lang="scss" scoped>
  .video-bar__column {
    width: 100%;
    max-width: 800px;
  }

  .iframe__wrapper {
    position: relative;
    padding-top: 56.25%;

    iframe {
      top: 0;
      left: 0;
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }

  @media all and (min-width: 769px) {
    .video-bar {
      padding: 2.5rem 0;
    }
  }
</style>
